import store from '@/store/index'
import axios from 'axios'

export default function setup() {
  axios.interceptors.request.use(
    function(config) {
      const token = store.getters.token
      if (token != null && token.token) {
        let expiryDate = new Date(token.expiry)
        if (config.url && !config.url.includes('auth/connect/refresh')) {
          expiryDate.setMinutes(expiryDate.getMinutes() - 10)
        }
        if (expiryDate < new Date()) {
          store.dispatch('refreshToken')
        }
        config.headers.Authorization = `Bearer ${token.token}`
      }

      return config
    },
    function(err) {
      return Promise.reject(err)
    },
  )
}
